// removed by extract-text-webpack-plugin
module.exports = {"Formalization":"Formalization__Formalization___u5Tfz","Title":"Formalization__Title___7QHL6","TitleClient":"Formalization__TitleClient___2VdW_","InnerClient":"Formalization__InnerClient___2vyg_","Row":"Formalization__Row___3Yuzx","Label":"Formalization__Label___E3cd5","Name":"Formalization__Name___EbLQN","RoomTypes":"Formalization__RoomTypes___2XlZt","FormalizationPrint":"Formalization__FormalizationPrint___Xutj_","Inner":"Formalization__Inner___34iWz","Client":"Formalization__Client___2hrLi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Formalization/Formalization.scss
// module id = 1360
// module chunks = 0